import { h } from "preact";
import { RoutableProps } from "preact-router";
import { OrderCreator } from "../../../components/OrderCreator";
import { sidraLEG } from "../../../data/serialNumberSearchExecs";
import "./styles.scss";

export function SidraLEGOrder(props: RoutableProps & { id?: string }) {
    return <div class="mezos-sit-order-page">
        <OrderCreator id={props.id} orderTypes={sidraLEG.orderTypes} serialRegexes={sidraLEG.orderedExecs}/>
    </div>;
}
